export default function Announcements(Restangular, RenderContent) {
  'ngInject';

  Restangular.extendModel('announcements', (announcement) => {
    if (announcement.content) {
      announcement.renderedContent = RenderContent.get(announcement.content);
    }

    if (announcement.author) {
      Restangular.restangularizeElement(null, announcement.author, 'users');
    }

    if (announcement.users) {
      Restangular.restangularizeCollection(null, announcement.users, 'users');

      announcement.users.forEach((user) => {
        user.read = announcement.readUserIds.includes(user.id);
      });
    }

    return announcement;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'announcements') {
      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }
    }

    return element;
  });

  return Restangular.service('announcements');
}
